import React, { useState } from "react";
import { Dialog, DialogContent, TextField } from "@mui/material";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import ModalActions from "../../common/ModalActions";

function Add({ open, onClose, onComicAdded }) {
  const [title, setTitle] = useState("");
  const [series, setSeries] = useState("");

  const handleAddComic = async () => {
    try {
      await addDoc(collection(db, "Comics"), {
        title,
        series,
      });
      setTitle("");
      setSeries("");
      onClose();
      onComicAdded(); // Call the callback to notify the parent
    } catch (error) {
      console.error("Error adding comic: ", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <ModalDialogTitle onClose={onClose}>Add New Comic</ModalDialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Title"
          fullWidth
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Series"
          fullWidth
          value={series}
          onChange={(e) => setSeries(e.target.value)}
        />
      </DialogContent>
      <ModalActions onSave={handleAddComic} saveLabel="Add" />
    </Dialog>
  );
}

export default Add;
